/**
 * Primary-field option shapes shared by the formula editor's field selector
 * and the query editor's Add Field Picker. Sourced from `finpubPrimaryFields`.
 */

export type PrimaryFieldLike = {
  name: string;
  displayName?: string | null;
  tableName?: string | null;
  type: string;
};

export type PrimaryFieldOption = {
  /** Canonical `<table>.<column>` identifier — the exact string referenced
   *  by formula expressions (`{.PrimaryField.<table>.<column>.}`) and
   *  `QueryFieldInput.primaryField`. */
  primaryField: string;
  /** User-facing label (`displayName`, falling back to `name`). */
  name: string;
  tableName: string | null;
  type: string;
};

export const toCanonicalPrimaryField = (
  name: string,
  tableName: string | null | undefined,
): string => {
  if (name.includes(".")) return name;
  return tableName ? `${tableName}.${name}` : name;
};

export const toPrimaryFieldOption = (field: PrimaryFieldLike): PrimaryFieldOption => {
  const primaryField = toCanonicalPrimaryField(field.name, field.tableName);
  return {
    primaryField,
    name: field.displayName || field.name,
    tableName: field.tableName ?? null,
    type: field.type,
  };
};

export const toPrimaryFieldOptions = (
  fields: ReadonlyArray<PrimaryFieldLike> | null | undefined,
): PrimaryFieldOption[] => (fields ?? []).map(toPrimaryFieldOption);
